<base-header logo="assets-global/images/stazzle-logo-dark-blue.svg"></base-header>
<div class="d-flex justify-content-center align-items-center mt-8">
  <section class="content-card teaser p-8">
    <div class="d-flex flex-column justify-content-between gap-8">
      <ng-content></ng-content>
    </div>
  </section>
</div>
